<mat-dialog-content>
  <div>

    <div *ngIf="isBroadcasting">
      <div class="monitor-gray">
        <mat-card-content class="monitor-picture">
          <img *ngIf="monitor.PictureURL" class="monitorImage" [imageSrc]="monitor.PictureURL" />
        </mat-card-content>
      </div>

      <mat-progress-bar *ngIf="monitor.ScreenState && monitor.ScreenState.ScreenContentMode == contentModes.Playlist"
        class="greenline-progress" [matTooltip]="monitor.ScreenState.AppTimeLeft" mode="determinate"
        [value]="monitor.ScreenState.AppPercentProgress" max="100"></mat-progress-bar>

      <div class="info" *ngIf="monitor.ScreenState && monitor.ScreenState.ScreenContentMode == contentModes.Playlist">
        <span class="title">{{monitor.ScreenState.PlaylistTitle}}</span>
        <span>{{monitor.ScreenState.ApplicationTitle}}</span>
      </div>
      <hr>
    </div>

    <div class="actions-list click-inside">
      <button [disabled]="!(monitor.AssignedPlaylist && monitor.Status == screenStatuses.Waiting)"
        (click)="monitor.playAssigned()">
        <div class="row">
          <mat-icon svgIcon="play_arrow" matTooltip="Play"></mat-icon>
          <span> Play </span>
        </div>
      </button>
      <button [disabled]="monitor.Status != screenStatuses.Playing" (click)="monitor.stopPlaylist()">

        <div class="row">
          <mat-icon svgIcon="stop" matTooltip="Stop"></mat-icon>
          <span> Stop</span>
        </div>

      </button>
      <button
        [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode != contentModes.SingleApp)"
        (click)="monitor.playNext()">
        <div class="row">
          <mat-icon svgIcon="fast_forward" matTooltip="Next"></mat-icon>
          <span> Next</span>
        </div>

      </button>
      <button
        [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode != contentModes.SingleApp)"
        (click)="monitor.playPrevious()">

        <div class="row">
          <mat-icon svgIcon="fast_rewind" matTooltip="Previous"></mat-icon>
          <span> Previous</span>
        </div>

      </button>
      <button
        [disabled]="!(monitor.Status == screenStatuses.Playing && monitor.ScreenState.ScreenContentMode == contentModes.SingleApp)"
        (click)="monitor.refreshPlaylist()">
        <div class="row">
          <mat-icon svgIcon="refresh" matTooltip="Refresh"></mat-icon>
          <span> Refresh</span>
        </div>

      </button>
      <button (click)="monitor.cleanMonitor()">
        <div class="row">
          <mat-icon svgIcon="clear" matTooltip="Clean screen"></mat-icon>
          <span>Clean screen</span>
        </div>

      </button>

      <button
        [disabled]="!(isRemoteControlEnabled$ | async)"
        (click)="onRemoteControl()">
          <div class="row">
            <mat-icon svgIcon="remote-control" matTooltip="Connect to remote screen"></mat-icon>
            <span>Remote control</span>
          </div>
      </button>

      <hr>

      <button (click)="openFullScreenView()">
        <div class="row">
          <mat-icon class="fullscreen" svgIcon="full_screen_mode" matTooltip="Share screen link"></mat-icon>
          <span>Share screen</span>
        </div>
      </button>

      <div class="assigned-monitor-tags click-inside" *ngIf="assignedMonitorTags?.length"
        (click)="$event.stopPropagation()">
        <hr>
        <p class="mb-1">Tags</p>
        <div class="assigned-monitor-tags__wrapper">
          <div class="assigned-monitor-tags__items w-100" *ngFor="let monitorTag of assignedMonitorTags">
            <mat-icon [ngStyle]="{ 'fill': monitorTag.Color }" class="tag__icon" svgIcon="tag-icon"></mat-icon>
            <span>{{ monitorTag.Title }}</span>
            <mat-icon svgIcon="close" [matTooltip]="MonitorTagDialogMessagesEnum.UnAssignMonitorFromMonitorTagTitle"
              (click)="unassignedMonitor(monitorTag)">
            </mat-icon>
          </div>
        </div>
      </div>

      <div class="click-inside">
        <hr>
        <div class="start-options" (click)="$event.stopPropagation()">
          <span matTooltip="Start options">Start options</span>
          <select [(ngModel)]="monitor.StartOptions" (change)="refreshStartOptions($event.target.value)">
            <option [value]="startOptions.Default">Default</option>
            <option [value]="startOptions.Playlist">Playlist</option>
          </select>
        </div>
        <div class="start-options" (click)="$event.stopPropagation()">
          <span matTooltip="Rename">Rename</span>
          <input #renameInput [(ngModel)]="title" (keydown)="onEnterPress($event)" (click)="onInputClick()" type="text"
            (focus)="isAllowToClose = false" (blur)="isAllowToClose = true">
          <button type="button" (click)="saveTitle()" matTooltip="OK">OK</button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
